'use client';

import { c as _c } from "react/compiler-runtime";
import { memo, type PropsWithChildren } from 'react';
import { HeaderLiquidation } from './HeaderLiquidation';
export interface LiquidationSectionLayoutProps extends PropsWithChildren {
  detailsCardsSlot: React.ReactNode;
  chartSlot: React.ReactNode;
  tableSlot: React.ReactNode;
}
const LiquidationSectionLayout = t0 => {
  const $ = _c(5);
  const {
    detailsCardsSlot,
    chartSlot,
    tableSlot
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HeaderLiquidation />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== chartSlot || $[2] !== detailsCardsSlot || $[3] !== tableSlot) {
    t2 = <div className="gap-2xs flex grow scroll-mt-[calc(var(--sticky-offset,0px)+16px)] flex-col" id="liquidation-section">{t1}<div className="gap-lg sm:gap-xl flex flex-col">{detailsCardsSlot}{chartSlot}{tableSlot}</div></div>;
    $[1] = chartSlot;
    $[2] = detailsCardsSlot;
    $[3] = tableSlot;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default memo(LiquidationSectionLayout);